export default __webpack_public_path__ + "static/media/data_¿que-necesito.c4a33656.png";